









































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class Home extends Vue {
  @Prop({type: String, default: ""}) public title
  @Prop({type: Number, default: 0}) public QQ
  @Prop({type: String, default: ""}) public wechat
  @Prop({type: Number, default: 0}) public phone
  /**
   * name
   */
  public copyText(e, item) {
    if (e.target.disabled) {
      return;
    }
    e.target.innerHTML = "复制成功"
    e.target.disabled = true
    setTimeout(() => {
      e.target.innerHTML = "复制"
      e.target.disabled = false
    }, 2000);
    const copyInput = document.createElement('input'); // 创建input元素
    document.body.appendChild(copyInput); // 向页面底部追加输入框
    copyInput.setAttribute('value', item); // 添加属性，将url赋值给input元素的value属性
    copyInput.select(); // 选择input元素
    document.execCommand("Copy"); // 执行复制命令
    // 复制之后再删除元素，否则无法成功赋值
    copyInput.remove(); // 删除动态创建的节点
  }
}
